import React from 'react'

import {
    EmptyThumb,
    RoomBadge,
    RoomButton,
    RoomCapacity,
    RoomContent,
    RoomHeader,
    RoomMeta,
    RoomName,
    RoomThumb,
} from './styles'
import imageIconUrl from '../../assets/icons/image.svg'
import seatIconUrl from '../../assets/icons/seat.svg'

import type { Room, RoomAvailability } from '../../models/rooms'

type RoomRowProps = {
    room: Room
    availability: RoomAvailability
    isAttached: boolean
    attachedLabel?: string
    isAttaching: boolean
    onAttach: (roomId: string) => void
}

function RoomThumbnail({ room }: { room: Room }) {
    if (room.thumb) {
        return <RoomThumb aria-hidden="true" $thumb={room.thumb} />
    }

    if (room.thumbKey) {
        return <RoomThumb aria-hidden="true" $thumbKey={room.thumbKey} />
    }

    return (
        <EmptyThumb aria-hidden="true">
            <img src={imageIconUrl} alt="" />
        </EmptyThumb>
    )
}

export function RoomRow({ room, availability, isAttached, attachedLabel = 'Attached', isAttaching, onAttach }: RoomRowProps) {
    const isAvailable = availability === true
    const isCheckingAvailability = availability === null
    const isDisabled = isAttaching || !isAvailable
    const availabilityLabel = isCheckingAvailability
        ? 'Checking availability...'
        : availability === 'error'
          ? 'Unable to check availability'
          : 'Unavailable for selected time'

    return (
        <RoomButton
            type="button"
            $attached={isAttached}
            $unavailable={!isAvailable}
            disabled={isDisabled}
            onClick={() => onAttach(room.id)}
        >
            <RoomThumbnail room={room} />

            <RoomContent>
                <RoomHeader>
                    <RoomName>{room.name}</RoomName>
                    {isAttached ? <RoomBadge>{attachedLabel}</RoomBadge> : null}
                </RoomHeader>
                <RoomMeta>{isAvailable ? room.details : availabilityLabel}</RoomMeta>
            </RoomContent>

            <RoomCapacity>
                <span>{isAttaching ? '...' : room.capacity}</span>
                <img src={seatIconUrl} alt="" aria-hidden="true" />
            </RoomCapacity>
        </RoomButton>
    )
}
